import { render, staticRenderFns } from "./LinkServiceModalV2.vue?vue&type=template&id=6ea27370&"
import script from "./LinkServiceModalV2.vue?vue&type=script&lang=js&"
export * from "./LinkServiceModalV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ea27370')) {
      api.createRecord('6ea27370', component.options)
    } else {
      api.reload('6ea27370', component.options)
    }
    module.hot.accept("./LinkServiceModalV2.vue?vue&type=template&id=6ea27370&", function () {
      api.rerender('6ea27370', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/branches/LinkServiceModalV2.vue"
export default component.exports